<template>

    <label class="switch">
        <input type="checkbox" :checked="checked" @input="$emit('input', $event)">
        <span class="grip round"></span>
    </label>

</template>

<style scoped lang="scss">

    .switch {
        display: inline-block;
        height: 20px;
        margin: 0;
        position: relative;
        width: 40px;
    }

    .switch input {
        height: 0;
        opacity: 0;
        width: 0;
    }

    .grip {
        background-color: $color-rule;
        bottom: 0;
        cursor: pointer;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: .3s;
    }

    .grip:before {
        background-color: $color-text;
        bottom: 0;
        content: "";
        height: 20px;
        left: 0;
        position: absolute;
        transition: all .3s;
        width: 20px;
    }

    input:checked + .grip {
        background-color: $color-rule;
    }

    input:checked + .grip:before {
        background-color: $color-primary;
        transform: translateX(20px);
    }

    .grip.round {
        border-radius: 20px;
    }

    .grip.round:before {
        border-radius: 50%;
    }

</style>

<script>

export default {

    props: {
        checked: {
            type: Boolean,
            default: false,
        },
    },

}

</script>